export default {
    path: '/legacy',
    name: 'landing-page-legacy',
    component: () => import('source/pages/LandingPageNew.vue'),
    meta: {
        title: 'HQZen - Find Zen in your workforce',
    },
};
